import Logo from '@scramble/design-system/logo/scramble_logo_white.svg';
import { Navigation } from '../../navigation';
import { UserMenu } from '../../user';
import type { DesktopNavigationProps } from '../../types';
import s from './index.module.scss';

export const DesktopNavigation = ({ menu = [], user }: DesktopNavigationProps): JSX.Element => {
  return (
    <div className={s.wrapper}>
      <div className={s.content}>
        <div className={s.logo}>
          <img src={Logo} alt="logo" width={112} height={20} />
        </div>
        <div className={s.navigation}>
          <Navigation menu={menu} />
        </div>
        <UserMenu user={user} />
      </div>
    </div>
  );
};
